module.exports = __webpack_public_path__ + "img/coupon_range_bg.eaa00e64.png";